export default __webpack_public_path__ + "static/media/search.ee87b443.svg";